<template>
  <v-sheet tile>
    <v-row justify="space-between" >
      <v-col cols="auto">
        <span class="title">{{caption}}</span>
      </v-col>
      <v-col cols="auto">
        <v-btn :loading="loadingState" color="primary"  text align="right" @click="addUser">
          Add
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense >
      <v-col cols="12" v-for="(user,index) in users" :key="index" lg="6" xs="12" sm="6" md="6">
        <v-list dense>
          <v-list-item dense class="break-words my-1">
            <v-list-item-content class="" dense>{{user}}</v-list-item-content>
            <v-list-item-action class="mt-0 mb-0">
              <v-btn :loading="loadingState" color='primary' icon @click="removeUser(user)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider ></v-divider>
        </v-list>
      </v-col>
    </v-row>
    <v-row dense >
      <v-col  cols="12" >
        <v-list>
            <template v-if="users.length == 0">{{empty_text}}</template>
        </v-list>
        </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "UsersList",
    props: ['caption', 'empty_text', 'users'],
    computed:{
        ...mapGetters(['loadingState']),
    },
    methods:
      {
        removeUser(user_to_remove) {
          var users = this.users.filter((item) => item != user_to_remove);
          this.$emit('updateUsers', users)
        },
        addUser() {
          var that = this
          var resolve_promise = undefined;
          var promise = new Promise((resolve, reject) => {
            resolve_promise = resolve
          }).then((user_to_add) => {
            var users = that.users.filter((item) => item != user_to_add);
            users.push(user_to_add)
            that.$emit('updateUsers', users)
          })
          this.$store.dispatch('showAddUserModal', resolve_promise)
        }
      },
  }
</script>

<style lang="scss" scoped>
  .title {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/Users/UsersList.vue